/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Body_Weight_TitleInputs */

const en_us2_progress_body_weight_title = /** @type {(inputs: Progress_Body_Weight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body weight`)
};

const pt_br2_progress_body_weight_title = /** @type {(inputs: Progress_Body_Weight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso corporal`)
};

const es_419_progress_body_weight_title = /** @type {(inputs: Progress_Body_Weight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso corporal`)
};

const pt_pt2_progress_body_weight_title = /** @type {(inputs: Progress_Body_Weight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso corporal`)
};

const fr_fr2_progress_body_weight_title = /** @type {(inputs: Progress_Body_Weight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids corporel`)
};

const de_de2_progress_body_weight_title = /** @type {(inputs: Progress_Body_Weight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körpergewicht`)
};

const it_it2_progress_body_weight_title = /** @type {(inputs: Progress_Body_Weight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso corporeo`)
};

/**
* | output |
* | --- |
* | "Body weight" |
*
* @param {Progress_Body_Weight_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_body_weight_title = /** @type {((inputs?: Progress_Body_Weight_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Body_Weight_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_body_weight_title(inputs)
	if (locale === "es-419") return es_419_progress_body_weight_title(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_body_weight_title(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_body_weight_title(inputs)
	if (locale === "de-DE") return de_de2_progress_body_weight_title(inputs)
	if (locale === "it-IT") return it_it2_progress_body_weight_title(inputs)
	return en_us2_progress_body_weight_title(inputs)
});
export { progress_body_weight_title as "progress.body_weight_title" }